import { useAuth0 } from "@auth0/auth0-react";
import SearchDownShift from "components/downmshift/DownShift";
import SearchAutoComplete from "components/SearchAutoComplete";
import { useFormik } from "formik";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import NotAuthorized from "../../../../components/NotAuthorized";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import LeftMenu from "../../leftMenu/LeftMenu";
import SettingHeader from "../../SettingHeader/settingHEader";

const AccountTpyes = ({ heading }) => {
  const [typeID, setTypeID] = useState("");
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [catagoryTypes, setCatagoryTypes] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [type, setType] = useState("");
  const { push } = useHistory();
  const [searchValue, setSearchValue] = useState("");
  const { path } = useRouteMatch();
  const [addPath, setAddPath] = useState();
  const [catagortById, setCatagortById] = useState({});
  const [forceSelectedId, setForceSelectedId] = useState(null);
  const [IsSettingsActive, setIsSettingsActive] = useState(true);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues:
      addNew === true
        ? {
          new_catagory_type: "",
          catagory_is_organization: true,
          catagory_is_member: true,
          catagory_is_not_member: true,
          allowedEasyCare: false,
        }
        : {
          new_catagory_type: catagortById.title ?? catagoryTypes[0]?.title,
          catagory_is_organization:
            catagortById.allowed_organization ??
            catagoryTypes[0]?.allowed_organization,
          catagory_is_member:
            catagortById.allowed_member ?? catagoryTypes[0]?.allowed_member,
          catagory_is_not_member:
            catagortById.allowed_not_member ??
            catagoryTypes[0]?.allowed_not_member,
          allowedEasyCare:
            catagortById?.allowedEasyCare ??
            catagoryTypes[0]?.allowedEasyCare,
        },
  });
  const initialStage = () => {
    formik.setFieldValue("new_catagory_type", catagoryTypes[0]?.title);
    formik.setFieldValue(
      "catagory_is_organization",
      catagoryTypes[0]?.allowed_organization
    );
    formik.setFieldValue(
      "catagory_is_member",
      catagoryTypes[0]?.allowed_member
    );
    formik.setFieldValue(
      "catagory_is_not_member",
      catagoryTypes[0]?.allowed_not_member
    );
  };
  const newCatogoryType = async () => {
    if (
      formik.values?.new_catagory_type == "" ||
      !formik.values?.new_catagory_type.match(
        /^(?![\s-])[\w\s:'-]+$/,
        "Enter a valid name"
      )
    ) {
      toastr.error("error", "Please enter a valid account type title");
    } else {
      const token = await getAccessTokenSilently();
      await MembersSettingService.CreateCatagoryType(
        {
          title: formik.values?.new_catagory_type,
          allowed_organization: formik.values?.catagory_is_organization,
          allowed_member: formik.values?.catagory_is_member,
          allowed_not_member: formik.values?.catagory_is_not_member,
          allowedEasyCare: formik.values?.allowedEasyCare,
        },
        token
      )
        .then((res) => {
          toastr.success("Success", "New Type has been created");
          const newId = res?.result?._id;
          const newTitle = formik.values?.new_catagory_type;
          getTypes();
          if (newId) {
            getCatagoryTypeById(newTitle, newId);
            setForceSelectedId(newId);
          }
        })
        .catch((e) => {
          toastr.error(e?.data?.message ?? "Error");
        });
    }
  };
  // Get catagory By Id
  const getCatagoryTypeById = async (type, id) => {
    setType(type);
    setTypeID(id);
    const token = await getAccessTokenSilently();
    await MembersSettingService.getCatagoryTypesById(id, token).then((res) => {
      setCatagortById(res.result);
    });
  };
  const getTypes = async () => {
    const token = await getAccessTokenSilently();
    return await MembersSettingService.getCatagoryTypesList(token)
      .then((res) => {
        const list = res.result.reverse();
        setCatagoryTypes(list);
        return list;
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      });
  };
  const option2 = catagoryTypes?.map((item, index) => ({
    id: item?._id,
    name: item?.title,
  }));
  // update Revrsal
  const updateCatagoryTypes = async () => {
    if (
      formik.values?.new_catagory_type == "" ||
      !formik.values?.new_catagory_type.match(
        /^(?![\s-])[\w\s:'-]+$/,
        "Enter a valid name"
      )
    ) {
      console.log("formik.value", formik.values?.new_catagory_type);
      toastr.error("error", "Please enter a valid account type title");
    } else {
      const currentId = typeID || catagoryTypes[0]?._id;
      const token = await getAccessTokenSilently();
      await MembersSettingService.updateCategoryTypesById(
        currentId,
        {
          title: formik.values?.new_catagory_type,
          allowed_organization: formik.values?.catagory_is_organization,
          allowed_member: formik.values?.catagory_is_member,
          allowed_not_member: formik.values?.catagory_is_not_member,
          allowedEasyCare: formik.values?.allowedEasyCare,
        },
        token
      )
        .then(() => {
          toastr.success("Success", "category Type has been updated");
          getTypes();
          if (currentId) getCatagoryTypeById(type, currentId);
        })
        .catch((error) => {
          toastr.error(
            "Update Error",
            error?.data?.message ?? "Some fields are missing"
          );
        });
    }
  };
  const deleteCatagoryType = async () => {
    const token = await getAccessTokenSilently();
    await MembersSettingService.deleteCatagoryTypesById(
      token,
      typeID || catagoryTypes[0]?._id
    ).then(async () => {
      const list = await getTypes();
      const first = list?.[0];
      if (first) {
        getCatagoryTypeById(first.title, first._id);
        setForceSelectedId(first._id);
      } else {
        setCatagortById({});
      }
    });
  };
  useEffect(() => {
    getTypes();
  }, []);
  const debounceSearch = useCallback(
    debounce(async () => {
      if (searchValue) {
        const token = await getAccessTokenSilently();
        await MembersSettingService.searchCategoryTypes(
          searchValue,
          token
        ).then((res) => {
          setCatagoryTypes(res.result);
        });
      }
    }, 1000),
    [searchValue]
  );
  useEffect(() => {
    if (searchValue === "") {
      getTypes();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);

  useEffect(() => {
    debounceSearch();
    return () => {
      debounceSearch.cancel();
    };
  }, [debounceSearch, searchValue]);
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
      setAddNew(false);
    }
  }, [pathname]);
  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "financial setting") {
        return setIsSettingsActive(item?.active);
      }
    });
  }, []);
  return IsSettingsActive == false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/financial-setting/members/account-types/view"}
        setAddNew={setAddNew}
        parentHeading={"Members"}
        alertOnEdit={edit}
      />
      <div className="main-setting__wrapper">
        <div className="col-md-4 mb-5 pl-7 pr-7">
          <SearchDownShift
            items={option2}
            name={searchValue}
            setName={setSearchValue}
            placeHolder="Search"
            autoFocus
          />
        </div>
        <div className="setting-main">
          <div className="left-menu-div">
            <LeftMenu
              getTypeId={getCatagoryTypeById}
              types={catagoryTypes ?? []}
              btnText={"New Account Category"}
              disableAddNew={disableAddNew}
              setAddNew={setAddNew}
              setDisable={setDisable}
              setDaisableAddNew={setDaisableAddNew}
              addPath={addPath}
              forceSelectedId={forceSelectedId}
            />
          </div>
          <div className="settings-details">
            <ComponentHeading
              type={formik.values?.new_catagory_type ?? type}
              heading={heading}
              addNew={addNew}
              disable={disable}
              setDaisableAddNew={setDaisableAddNew}
              setDisable={setDisable}
              edit={edit}
              setEdit={setEdit}
              setAddPath={setAddPath}
              updateFunc={updateCatagoryTypes}
              formik={formik}
              createFunc={newCatogoryType}
              setAddNew={setAddNew}
              deleteFunc={deleteCatagoryType}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountTpyes;
